import { massiveDownloadPostParameters, massiveDownloadSaveConfig, massiveDownloadGetConfigList, massiveDownloadGetJobList } from '@/app/massive_download/services/MassiveDownloadService'
import MassiveDownloadPost from '@/app/massive_download/models/MassiveDownloadPost'
import MassiveDownloadPostSaveUserConfig from '@/app/massive_download/models/MassiveDownloadPostSaveUserConfig'
import MassiveDownloadConfig from '@/app/massive_download/models/MassiveDownloadConfig'
import { getSelectedOptionId } from '@/app/shared/utils/Option'
import MassiveDownload from '@/app/massive_download/models/MassiveDownload'
import MassiveDownloadJob from '@/app/massive_download/models/MassiveDownloadJob'

const NAMESPACE = 'massiveDownload/'
// Required Selection
export const MUTATE_GRANULARITY = NAMESPACE + 'MUTATE_GRANULARITY'
export const MUTATE_DATE_RANGE = NAMESPACE + 'MUTATE_DATE_RANGE'
export const MUTATE_DATE_FROM = NAMESPACE + 'MUTATE_DATE_FROM'
export const MUTATE_DATE_TO = NAMESPACE + 'MUTATE_DATE_TO'
export const MUTATE_FILTERS = NAMESPACE + 'MUTATE_FILTERS'
export const MUTATE_RESET_FILTERS = NAMESPACE + 'MUTATE_RESET_FILTERS'
export const MUTATE_DYNAMIC_DATE = NAMESPACE + 'MUTATE_DYNAMIC_DATE'
export const MUTATE_INIT_DYNAMIC_DATE = NAMESPACE + 'MUTATE_INIT_DYNAMIC_DATE'
export const MUTATE_STORE_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'MUTATE_STORE_PRODUCT_DIMENSION_SELECTED_IDS'

export const ACTION_SET_GRANULARITY = NAMESPACE + 'SET_GRANULARITY'
export const ACTION_SET_DATE_RANGE = NAMESPACE + 'SET_DATE_RANGE'
export const ACTION_SET_DATE_FROM = NAMESPACE + 'SET_DATE_FROM'
export const ACTION_SET_DATE_TO = NAMESPACE + 'SET_DATE_TO'
export const ACTION_SET_DYNAMIC_DATE = NAMESPACE + 'SET_DYNAMIC_DATE'
export const ACTION_SET_INIT_DYNAMIC_DATE = NAMESPACE + 'SET_INIT_DYNAMIC_DATE'

export const GETTER_DYNAMIC_DATE_SELECTED = NAMESPACE + 'GETTER_DYNAMIC_DATE_SELECTED'
// Column Selection
export const MUTATE_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'MUTATE_PRODUCT_DIMENSION_SELECTED_IDS'
export const MUTATE_STORE_DIMENSION_SELECTED_IDS = NAMESPACE + 'MUTATE_STORE_DIMENSION_SELECTED_IDS'

export const ACTION_SET_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'SET_PRODUCT_DIMENSION_SELECTED_IDS'
export const ACTION_SET_STORE_DIMENSION_SELECTED_IDS = NAMESPACE + 'SET_STORE_DIMENSION_SELECTED_IDS'
// Module
export const MUTATE_USER_CONFIG_LIST = NAMESPACE + 'MUTATE_USER_CONFIG_LIST'

export const ACTION_GENERATE_REPORT = NAMESPACE + 'GENERATE_REPORT'
export const ACTION_SAVE_USER_CONFIG = NAMESPACE + 'SAVE_USER_CONFIG'
export const ACTION_FETCH_USER_CONFIG_LIST = NAMESPACE + 'FETCH_USER_CONFIG_LIST'
export const ACTION_FETCH_JOB_LIST = NAMESPACE + 'FETCH_JOB_LIST'

export const MUTATE_INIT_MASSIVE_DOWNLOAD = NAMESPACE + 'MUTATE_MASSIVE_DOWNLOAD'
export const MUTATE_USER_CONFIG = NAMESPACE + 'MUTATE_USER_CONFIG'
export const MUTATE_JOB_LIST = NAMESPACE + 'MUTATE_JOB_LIST'

export const ACTION_SET_DEFAULT_PARAMETERS = NAMESPACE + 'SET_DEFAULT_PARAMETERS'
export const ACTION_SET_USER_CONFIG = NAMESPACE + 'SET_USER_CONFIG'

export const GETTER_DYNAMIC_DATE_SELECTED_ID = NAMESPACE + 'GETTER_DYNAMIC_DATE_SELECTED_ID'
export const GETTER_DYNAMIC_DATE_BY_ID = NAMESPACE + 'GETTER_DYNAMIC_DATE_BY_ID'
export const GETTER_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'GETTER_PRODUCT_DIMENSION_SELECTED_IDS'
export const GETTER_STORE_DIMENSION_SELECTED_IDS = NAMESPACE + 'GETTER_STORE_DIMENSION_SELECTED_IDS'
export const GETTER_STORE_PRODUCT_DIMENSION_SELECTED_IDS = NAMESPACE + 'GETTER_STORE_PRODUCT_DIMENSION_SELECTED_IDS'
export const GETTER_GRANULARITY_BY_ID = NAMESPACE + 'GETTER_GRANULARITY_BY_ID'
export const GETTER_DYNAMIC_DATE_MAP_ID = NAMESPACE + 'GETTER_DYNAMIC_DATE_MAP_ID'

const MassiveDownloadState = {
  state: {
    jobList: null,
    userConfigList: null,
    defaultRequiredSelection: null,
    defaultColumnSelection: null,
    selectedGranularity: null,
    selectedDateFrom: null,
    selectedDateTo: null,
    selectedProductDimensionIds: [],
    selectedStoreDimensionIds: [],
    selectedStoreProductDimensionIds: [],
    selectedProductFilters: {},
    selectedStoreFilters: {},
    dynamicDateMapId: new Map()

  },
  getters: {
    [GETTER_DYNAMIC_DATE_SELECTED]: (state) => {
      return state.dynamicDateMapId.get(state.selectedGranularity.id)
    },
    [GETTER_DYNAMIC_DATE_SELECTED_ID]: (state) => (granularityId) => {
      const filteredOptions = state.defaultRequiredSelection.dateSelection.dynamicDate.options.filter(option => option.granularity === granularityId)
      return getSelectedOptionId(filteredOptions)
    },
    [GETTER_DYNAMIC_DATE_BY_ID]: (state) => (id) => {
      return state.defaultRequiredSelection.dateSelection.dynamicDate.options.find(option => option.id === id)
    },
    [GETTER_PRODUCT_DIMENSION_SELECTED_IDS]: (state) => {
      return state.defaultColumnSelection.productDimensions.options
        .filter(productDimensionOption => productDimensionOption.selected)
        .map(productDimensionOption => productDimensionOption.value)
    },
    [GETTER_STORE_DIMENSION_SELECTED_IDS]: (state) => {
      return state.defaultColumnSelection.storeDimensions.options
        .filter(storeDimensionOption => storeDimensionOption.selected)
        .map(storeDimensionOption => storeDimensionOption.value)
    },
    [GETTER_STORE_PRODUCT_DIMENSION_SELECTED_IDS]: (state) => {
      return state.defaultColumnSelection.storeProductDimensions.options
        .filter(storeProductDimension => storeProductDimension.selected)
        .map(storeProductDimension => storeProductDimension.value)
    },
    [GETTER_GRANULARITY_BY_ID]: (state) => (id) => {
      return state.defaultRequiredSelection.granularity.options.find(option => option.id === id)
    },
    [GETTER_DYNAMIC_DATE_MAP_ID]: (state) => {
      const dynamicDateMapId = new Map()
      state.defaultRequiredSelection.dateSelection.dynamicDate.options
        .filter(option => option.selected)
        .forEach(option => dynamicDateMapId.set(option.granularity, option.id))
      return dynamicDateMapId
    }
  },
  mutations: {
    [MUTATE_GRANULARITY] (state, granularity) {
      state.selectedGranularity = granularity
    },
    [MUTATE_DYNAMIC_DATE] (state, { dynamicDateId }) {
      state.dynamicDateMapId.set(state.selectedGranularity.id, dynamicDateId)
    },
    [MUTATE_INIT_DYNAMIC_DATE] (state, dynamicDateMapId) {
      state.dynamicDateMapId = dynamicDateMapId
    },
    [MUTATE_DATE_RANGE] (state, { from, to }) {
      state.selectedDateFrom = from
      state.selectedDateTo = to
    },
    [MUTATE_DATE_FROM] (state, { dateFrom }) {
      state.selectedDateFrom = dateFrom
    },
    [MUTATE_DATE_TO] (state, { dateTo }) {
      state.selectedDateTo = dateTo
    },
    [MUTATE_PRODUCT_DIMENSION_SELECTED_IDS] (state, { productDimensionIds }) {
      state.selectedProductDimensionIds = productDimensionIds
    },
    [MUTATE_STORE_DIMENSION_SELECTED_IDS] (state, { storeDimensionIds }) {
      state.selectedStoreDimensionIds = storeDimensionIds
    },
    [MUTATE_STORE_PRODUCT_DIMENSION_SELECTED_IDS] (state, storeProductDimensionIds) {
      state.selectedStoreProductDimensionIds = storeProductDimensionIds
    },
    [MUTATE_FILTERS] (state, { productFilters, storeFilters }) {
      state.selectedProductFilters = productFilters
      state.selectedStoreFilters = storeFilters
    },
    [MUTATE_RESET_FILTERS] (state) {
      state.selectedProductFilters = {}
      state.selectedStoreFilters = {}
    },
    [MUTATE_USER_CONFIG_LIST] (state, userConfigList) {
      state.userConfigList = userConfigList
    },
    [MUTATE_INIT_MASSIVE_DOWNLOAD] (state, defaultParameters) {
      state.defaultRequiredSelection = defaultParameters.requiredSelection
      state.defaultColumnSelection = defaultParameters.columnSelection
    },
    [MUTATE_USER_CONFIG] (state, userConfigParameters) {
      state.defaultRequiredSelection.dateSelection.dynamicDate.options.map((option, index) => {
        userConfigParameters.requiredSelection.dateSelection.dynamicDate.options.splice(index, 1, {
          ...userConfigParameters.requiredSelection.dateSelection.dynamicDate.options[index],
          from: option.from,
          to: option.to
        })
      })
      const userConfig = new MassiveDownload({ ...userConfigParameters })
      state.defaultRequiredSelection = userConfig.requiredSelection
      state.defaultColumnSelection = userConfig.columnSelection
      state.selectedProductFilters = userConfig.filterSelection.productFilters
      state.selectedStoreFilters = userConfig.filterSelection.storeFilters
    },
    [MUTATE_JOB_LIST] (state, jobList) {
      state.jobList = jobList
    }
  },
  actions: {
    [ACTION_SET_GRANULARITY] ({ commit }, granularity) {
      commit(MUTATE_GRANULARITY, granularity)
    },
    [ACTION_SET_DYNAMIC_DATE] ({ commit }, dynamicDateId) {
      commit(MUTATE_DYNAMIC_DATE, { dynamicDateId })
    },
    [ACTION_SET_INIT_DYNAMIC_DATE] ({ commit }, dynamicDateMapId) {
      commit(MUTATE_INIT_DYNAMIC_DATE, dynamicDateMapId)
    },
    [ACTION_SET_DATE_RANGE] ({ commit }, { from, to }) {
      commit(MUTATE_DATE_RANGE, { from, to })
    },
    [ACTION_SET_DATE_FROM] ({ commit }, dateFrom) {
      commit(MUTATE_DATE_FROM, { dateFrom })
    },
    [ACTION_SET_DATE_TO] ({ commit }, dateTo) {
      commit(MUTATE_DATE_TO, { dateTo })
    },
    [ACTION_SET_PRODUCT_DIMENSION_SELECTED_IDS] ({ commit }, productDimensionIds) {
      commit(MUTATE_PRODUCT_DIMENSION_SELECTED_IDS, { productDimensionIds })
    },
    [ACTION_SET_STORE_DIMENSION_SELECTED_IDS] ({ commit }, storeDimensionIds) {
      commit(MUTATE_STORE_DIMENSION_SELECTED_IDS, { storeDimensionIds })
    },
    async [ACTION_GENERATE_REPORT] ({ commit, state }, { stock, productFilters, storeFilters }) {
      commit(MUTATE_FILTERS, { productFilters, storeFilters })
      const massiveDownloadPost = new MassiveDownloadPost({ ...state, stock })
      await massiveDownloadPostParameters(massiveDownloadPost.parameters)
      commit(MUTATE_RESET_FILTERS)
    },
    async [ACTION_SAVE_USER_CONFIG] ({ commit, state }, { reportName, reportDescription, defaultSelection }) {
      const defaultSelectionDeepCopy = JSON.parse(JSON.stringify(defaultSelection))
      const massiveDownloadPostSaveUserConfig = new MassiveDownloadPostSaveUserConfig({ ...state, reportName, reportDescription, defaultSelectionDeepCopy })
      await massiveDownloadSaveConfig(massiveDownloadPostSaveUserConfig.body)
    },
    async [ACTION_FETCH_USER_CONFIG_LIST] ({ commit }) {
      const userConfigList = await massiveDownloadGetConfigList()
      const massiveDownloadUserConfigList = userConfigList
        .map(userConfig => new MassiveDownloadConfig(userConfig))
      commit(MUTATE_USER_CONFIG_LIST, massiveDownloadUserConfigList)
    },
    async [ACTION_SET_DEFAULT_PARAMETERS] ({ commit }, defaultParameters) {
      const massiveDownloadDefaultParameters = new MassiveDownload({ ...defaultParameters })
      commit(MUTATE_INIT_MASSIVE_DOWNLOAD, massiveDownloadDefaultParameters)
    },
    async [ACTION_SET_USER_CONFIG] ({ commit }, userConfigParameters) {
      const userConfig = new MassiveDownload({ ...userConfigParameters })
      commit(MUTATE_USER_CONFIG, userConfig)
    },
    async [ACTION_FETCH_JOB_LIST] ({ commit }) {
      const jobList = await massiveDownloadGetJobList()
      const massiveDownloadJobList = jobList.map(job => new MassiveDownloadJob(job))
      commit(MUTATE_JOB_LIST, massiveDownloadJobList)
    }
  }
}

export default MassiveDownloadState



// WEBPACK FOOTER //
// ./src/app/massive_download/MassiveDownloadState.js